import { Grid, Typography, useViewport } from '@lamimed/pantheon';
import Head from 'next/head';

import { footerImageOffset } from 'components/Footer/styles';
import { Header } from 'components/Header';
import { SectionWrapper } from 'components/wrappers/SectionWrapper';

import * as S from './styles';

const TermsAndConditions: React.FC = () => {
  const { greaterThan } = useViewport();

  return (
    <>
      <Head>
        <title key="title">Termini e condizioni - Lami: Health delivery</title>
      </Head>

      <Header />

      <SectionWrapper
        paddingBottom={greaterThan('tablet') ? 'xxlarge' : 'xlarge'}
        additionalPadding={footerImageOffset}
        paddingTop="none"
      >
        <S.Wrapper>
          <Grid.Wrapper>
            <Typography
              variant="heading_1"
              color="text__highlight"
              as="h1"
              textAlign="center"
              marginBottom="medium"
            >
              Termini e condizioni del software Lamimed
            </Typography>

            <Typography marginBottom="medium">
              Di seguito sono riportati i termini e le condizioni di utilizzo
              applicabili ad ogni visitatore di questo sito web di Lami S.r.l..
            </Typography>

            <Typography marginBottom="medium">
              I presenti termini e condizioni si applicano alla vendita dei
              servizi proposti dal network di siti e applicazioni Lami, tra cui
              il sito www.lamimed.it con esclusivo riferimento agli acquisti
              effettuati sul sito conformemente alle disposizioni della Parte
              III, Titolo III, Capo I, Codice del Consumo (D.lgs. n. 206/05
              modificato dal D.lgs. n. 21/14 e D.lgs. 70/03).
            </Typography>

            <Typography marginBottom="medium">
              L&apos;accesso e l&apos;utilizzo dei servizi Lami comporta,
              pertanto, l&apos;accettazione espressa ed incondizionata degli
              stessi termini e condizioni nonché della normativa vigente in
              materia da parte del visitatore. L&apos;utente è tenuto, prima di
              accedere ai servizi forniti dal sito, a leggere i presenti termini
              e condizioni che si intendono generalmente ed inequivocabilmente
              accettati al momento dell&apos;adesione.
            </Typography>

            <Typography marginBottom="medium">
              Lami S.r.l. si riserva il diritto di modificare o semplicemente
              aggiornare, in tutto o in parte, i termini e le condizioni qui
              riportate. Le modifiche e gli aggiornamenti delle condizioni
              generali d&apos;uso saranno vincolanti non appena pubblicati sul
              sito web in questa stessa sezione. Poiché i termini, le condizioni
              e le loro revisioni sono vincolanti per il visitatore del sito,
              quest&apos;ultimo è tenuto a consultarli periodicamente per
              prendere conoscenza degli aggiornamenti. Nel caso in cui l&apos;
              Utente non accetti i nuovi termini e condizioni del sito, è tenuto
              a non a non utilizzare i servizi offerti.
            </Typography>

            <Typography marginBottom="medium">
              Si raccomanda di stampare e conservare una copia dei presenti
              termini e condizioni per futura consultazione.
            </Typography>

            <Typography marginBottom="medium">
              Registrandosi a questo Sito si dichiara di avere già compiuto 18
              anni.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 1 – Informazioni relative a Lami
            </Typography>

            <Typography marginBottom="medium">
              1.1. Lami S.r.l. è una società di diritto italiano con sede legale
              in Via Ariberto 8, 20123 Milano, P.IVA 11507850961 e indirizzo PEC
              lami.pec@legalmail.it.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 2 – Definizioni
            </Typography>

            <Typography marginBottom="medium">
              2.1. Di seguito viene indicato il significato dei principali
              termini impiegati nel presente Contratto:
            </Typography>

            <S.List>
              <S.Item>
                per “Software” si intende la piattaforma informatica di tipo
                SaaS (Software as a Service) denominata Lami, resa disponibile
                attraverso reti telematiche in modalità web;
              </S.Item>

              <S.Item>
                per “Utente” o “Paziente” si intende qualsiasi soggetto, persona
                fisica, destinataria del Servizio, che iscrivendosi alla
                piattaforma Lami desidera prenotare prestazioni sanitarie
                extra-ospedaliere a domicilio;
              </S.Item>

              <S.Item>
                per “Libero Professionista” si intende il soggetto, persona
                fisica o giuridica, aderente al servizio Lami, che offre la
                prestazione sanitaria extra-ospedaliera richiesta dal Paziente
                in regime di libera professione;
              </S.Item>

              <S.Item>
                per “Partner territoriali Lami” si intende qualsiasi soggetto,
                persona fisica o giuridica, il quale nell&apos;esercizio della
                propria attività imprenditoriale o commerciale, aderisca al
                progetto Lami al fine di utilizzare il Software quale mezzo
                produttivo nell&apos;ambito della propria attività;
              </S.Item>

              <S.Item>
                per “Dati personali” si intende qualunque informazione fornita
                direttamente dall&apos;Utente e ricompresa nella definizione di
                cui all&apos;art. 4, par.1, n. 1) del Regolamento UE 2016/679;
              </S.Item>

              <S.Item>
                per “Dati relativi alla salute” si intende qualunque
                informazione fornita direttamente dal Paziente e resa visibile
                ai Liberi Professionisti tramite il Software e ricompresa nella
                definizione di cui all&apos;art. 4, par. 1, n. 15) del
                Regolamento UE 2016/679;
              </S.Item>

              <S.Item>
                per “Dati di particolare rilevanza” si intende qualunque
                informazione fornita direttamente dal Paziente e resa visibile
                ai Liberi Professionisti tramite il Software e ricompresa nella
                definizione di cui all&apos;art. 9, par. 1, del Regolamento UE
                2016/679;
              </S.Item>

              <S.Item>
                per “Titolare del Trattamento Dati” si intende la persona fisica
                o giuridica, l&apos;autorità pubblica, il servizio o altro
                organismo che, singolarmente o insieme ad altri, determina le
                finalità e i mezzi del trattamento di dati personali ai sensi
                dell&apos;art. 4, par.1, n.7 del Regolamento UE 2016/679;
              </S.Item>

              <S.Item>
                per “Informazioni riservate” si intende qualunque informazione
                fornita direttamente dall&apos;Utente tutelata come segreta ai
                sensi degli art. 98 e 99 del Codice della Proprietà Industriale,
                D.lgs. 10 febbraio 2005, n. 30.
              </S.Item>
            </S.List>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 3 – Oggetto
            </Typography>

            <Typography marginBottom="medium">
              3.1. Lami S.r.l. fornisce agli Utenti un sistema per la
              prenotazione di prestazioni sanitarie extraospedaliere a domicilio
              attraverso la tecnologia della piattaforma Lami. Il contratto per
              l&apos;erogazione della prestazione sanitaria desiderata è
              concluso esclusivamente tra l&apos;Utente e il Libero
              Professionista sanitario iscritto alla piattaforma. L&apos;Utente
              inoltra la richiesta di prestazione tramite la piattaforma e Lami
              S.r.l. conclude la vendita del servizio sanitario per conto dei
              Liberi Professionisti.
            </Typography>

            <Typography marginBottom="medium">
              3.2. Tutti i Liberi Professionisti aderenti al network Lami sono
              qualificati e professionali, regolarmente iscritti all&apos;albo
              di categoria o, quando questo non sia previsto, alla federazione
              nazionale di settore e sono in possesso di polizza RC
              professionale in corso di validità. In assenza di tali requisiti,
              il Libero Professionista non può aderire al servizio e offrire
              prestazioni.
            </Typography>

            <Typography marginBottom="medium">
              3.3.In ogni caso, Lami S.r.l. non ha alcun obbligo di garantire
              l&apos;accettazione da parte dei Liberi Professionisti delle
              prestazioni richieste dagli Utenti. Lami S.r.l. non gestisce
              richieste di prestazioni sanitarie urgenti o di emergenza e
              nessuna responsabilità potrà esserle imputata al riguardo.
            </Typography>

            <Typography marginBottom="medium">
              3.4. L&apos;Utente riconosce che Lami non fornisce servizi
              sanitari né opera come professionista sanitario o struttura
              sanitaria e che tutti detti servizi sanitari sono forniti da terzi
              professionisti indipendenti che non sono alle dipendenze di Lami.
            </Typography>

            <Typography marginBottom="medium">
              3.5. L&apos;Utente comprende e accetta che la registrazione a Lami
              S.r.l necessita il trattamento dei propri dati personali per
              l&apos;erogazione del servizio e, laddove espressamente
              acconsentito, anche per l&apos;eventuale futuro aggiornamento
              sulle attività di Lami S.r.l e lo sviluppo delle proprie attività
              di partnership nel settore sanitario.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 4 – Modalità di adesione e Account Personale
            </Typography>

            <Typography marginBottom="medium">
              4.1. Per fruire del Software l&apos;Utente deve registrarsi presso
              il sito internet dedicato www.lamimed.it.
            </Typography>

            <Typography marginBottom="medium">
              4.2. La registrazione si effettua compilando l&apos;apposito form
              on line, previa lettura e accettazione mediante modalità “punta e
              clicca” (i) delle presenti Condizioni e Termini di Utilizzo oltre
              che delle Clausole specifiche ex artt. 1341 e 1342 c.c; (ii)
              dell&apos;Informativa Privacy ex art. 13 del Regolamento UE
              2016/679.
            </Typography>

            <Typography marginBottom="medium">
              4.3. L&apos;Utente può utilizzare esclusivamente il proprio
              account. È vietato l&apos;utilizzo dell&apos;account di un altro
              Utente.
            </Typography>

            <Typography marginBottom="medium">
              4.4. L&apos;Utente è tenuto a conservare e custodire le
              credenziali di accesso nella massima sicurezza e segretezza ed è
              direttamente responsabile per qualsiasi danno, diretto o
              indiretto, che l&apos;uso improprio o non autorizzato delle
              credenziali di accesso dovesse arrecare a Lami o a terze parti.
              L&apos;utente è tenuto ad informare prontamente Lami di qualsiasi
              eventuale loro uso non autorizzato o del loro smarrimento, a mezzo
              e-mail affinché la stessa possa sospendere l&apos;erogazione dei
              propri servizi con riferimento all &apos;account. Qualora accada
              che, sia intervenuto un accesso non autorizzato all&apos;account
              dell&apos;utente e/o lo stesso abbia smarrito la sua username e/o
              la sua password per più di tre volte, Lami si riserva la facoltà
              di rimuovere l&apos;account dell&apos; Utente senza che questi
              abbia nulla a pretendere nei suoi confronti.
            </Typography>

            <Typography marginBottom="medium">
              4.4. L&apos;Utente può inserire nel proprio profilo un ulteriore
              profilo di un minorenne sul quale eserciti la potestà genitoriale
              e/o di una persona maggiorenne che assista in qualità di
              caregiver. In questa seconda ipotesi, l&apos;Utente è obbligato a
              richiedere e ottenere dalla persona maggiorenne, tramite il
              processo guidato, l&apos;autorizzazione all&apos;inserimento del
              suo profilo e alla relativa gestione. Tale autorizzazione potrà
              essere revocata dall&apos;assistito in qualsiasi momento.
            </Typography>

            <Typography marginBottom="medium">
              4.5. Lami non potrà essere ritenuta in alcun modo responsabile,
              direttamente o indirettamente, in qualsiasi forma o sulla base di
              qualsivoglia regime di responsabilità, per lesioni o danni di
              qualsiasi genere risultanti da, o correlati a, il mancato rispetto
              da parte dell&apos;Utente delle disposizioni di cui al presente
              articolo. Lami sarà libera di inibire l&apos;accesso di un Utente
              al proprio Account e/o di interrompere l&apos;operatività della
              username e/o della password dello stesso, qualora ritenga che sia
              intervenuta una sostanziale violazione delle presenti condizioni
              generali d&apos; uso ed in particolare di quanto dopo previsto,
              ovvero qualora l&apos; Utente compia un uso illecito o scorretto
              dei servizi del sito.
            </Typography>

            <Typography marginBottom="medium">
              4.6. L&apos;utente sarà inoltre tenuto a non effettuare né a
              consentire o permettere a terzi i seguenti comportamenti (non
              esaustivi e in continuo aggiornamento):
            </Typography>

            <S.List>
              <S.Item>
                il caricamento o la creazione all&apos;interno dell&apos;area
                cliente di qualsiasi dato o contenuto che sia in violazione di
                qualsivoglia legge, regolamento o diritto di terzi (ivi
                compresi, tra gli altri, segreti commerciali o dati personali di
                terzi);
              </S.Item>

              <S.Item>
                l&apos;utilizzazione dei servizi della società per scopi diversi
                dal mero accesso agli stessi nelle modalità in cui sono forniti
                dalla stessa;
              </S.Item>

              <S.Item>
                effettuare azioni di qualunque genere e/o natura volte ad
                aggirare, disattivare ovvero interferire in qualsiasi modo con
                gli applicativi correlati alla sicurezza dei servizi del sito o
                altri applicativi che prevengano, limitino ovvero restringano l
                &apos; utilizzo ovvero la copia di qualsiasi materiale presente
                sullo stesso;
              </S.Item>

              <S.Item>
                utilizzazione dei servizi del sito per qualsivoglia scopo
                illecito o in violazione di qualsiasi normativa applicabile;
              </S.Item>

              <S.Item>
                interferire o danneggiare i servizi e i sistemi del sito ovvero
                il loro relativo godimento da parte di qualsivoglia utente, con
                qualsiasi mezzo, compreso mediante il caricamento di files o
                comunque disseminando virus, adware, spyware, bachi o altri
                strumenti elettronici nocivi;
              </S.Item>

              <S.Item>
                effettuare azioni volte ad aggirare strumenti per l&apos;
                esclusione di robot o altre misure che il sito possa utilizzare
                per prevenire accessi non autorizzati ai servizi della stessa.
              </S.Item>
            </S.List>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 5 – Modalità di prenotazione delle prestazioni sanitarie
            </Typography>

            <Typography marginBottom="medium">
              5.1. Per poter prenotare la prestazione l&apos;Utente deve
              accedere al proprio Account personale inserendo le credenziali di
              accesso scelte in fase di registrazione.
            </Typography>

            <Typography marginBottom="medium">
              5.2. Selezionando la prestazione per cui desidera richiedere la
              prestazione, l&apos;Utente visualizzerà l&apos;elenco delle
              categorie dei vari professionisti disponibili nella zona, delle
              prestazioni sanitarie offerte e il relativo costo. Una volta
              scelta la prestazione desiderata e il professionista e inseriti
              gli ulteriori dati richiesti dal sistema, l&apos;Utente potrà
              finalizzare la prenotazione.
            </Typography>

            <Typography marginBottom="medium">
              5.3. Si ricorda che è importante controllare tutte le informazioni
              immesse e correggere eventuali errori prima di cliccare sul
              pulsante di prenota poiché, dopo averlo fatto, l&apos;Utente
              concluderà l&apos;invio della richiesta e non sarà più possibile
              correggere eventuali errori.
            </Typography>

            <Typography marginBottom="medium">
              5.4. Alla ricezione della richiesta di prestazione Lami trasmette
              la stessa al Libero Professionista selezionato e invia
              all&apos;Utente un sms di conferma. Alla ricezione del sms di
              conferma la prestazione viene definitivamente accettata dal Libero
              Professionista e si conclude il contratto tra questo e
              l&apos;Utente.
            </Typography>

            <Typography marginBottom="medium">
              5.5. L&apos;Utente ha la facoltà di annullare la richiesta in
              qualsiasi momento. Tuttavia, qualora l&apos;annullamento
              intervenga successivamente all&apos;accettazione definitiva della
              prestazione da parte del Libero Professionista, Lami si riserva il
              diritto di applicare una penale pari al costo della prestazione
              richiesta al netto dei costi di servizio. Novo 15h49 Art. 6 –
              Prezzi e Pagamento 15h49 6.1. I prezzi delle prestazioni sono
              quelli indicati sulla piattaforma alla dicitura “Prezzo”. I prezzi
              sono comprensivi del valore della prestazione del
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 6 – Prezzi e Pagamento
            </Typography>

            <Typography marginBottom="medium">
              6.1. I prezzi delle prestazioni sono quelli indicati sulla
              piattaforma alla dicitura “Prezzo”. I prezzi sono comprensivi del
              valore della prestazione del Libero Professionista, dei costi di
              utilizzo del servizio offerto da Lami, cosi come di IVA.
            </Typography>

            <Typography marginBottom="medium">
              6.2. Il pagamento delle prestazioni può essere effettuato mediante
              una carta di credito/debito o altro strumento di pagamento
              elettronico direttamente al Libero Professionista tramite POS.
            </Typography>

            <Typography marginBottom="medium">
              6.3. Entro 48 dall&apos;avvenuto pagamento del compenso, Lami
              provvederà a inviare la fattura all&apos;indirizzo mail indicato
              dall&apos;Utente in fase di completamento della registrazione.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 7 – Garanzie e Limitazioni di Responsabilità
            </Typography>

            <Typography marginBottom="medium">
              7.1. Ogni condizione o garanzia non espressamente indicata nel
              presente contratto è esclusa.
            </Typography>

            <Typography marginBottom="medium">
              7.2. Il Software viene fornito privo di errori, vizi e/o
              malfunzionamenti.
            </Typography>

            <Typography marginBottom="medium">
              7.3. Viene esclusa qualsiasi responsabilità di Lami per il
              risarcimento di eventuali danni, diretti e/o indiretti,
              patrimoniali e non, che dovessero derivare all&apos; Utente o a
              terzi dall&apos;indebito utilizzo del Software da parte
              dell&apos;Utente stesso, nonché per i danni tutti che non siano
              imputabili a dolo o colpa grave di Lami. Viene altresì esclusa
              qualsiasi forma di responsabilità di Lami con riferimento ai tempi
              di caricamento ed elaborazione dei file in dipendenza di fattori
              estranei la funzionalità del Software, quali dimensioni del file,
              loro contenuto, banda internet a disposizione e, in ogni caso, per
              qualsiasi altro fatto non dipendente dall&apos;operato di Lami.
            </Typography>

            <Typography marginBottom="medium">
              7.4. L&apos;Utente riconosce che il presente contratto disciplina
              esclusivamente il servizio di prenotazione offerto dal Software,
              senza in alcun modo interferire in merito alla prestazione
              sanitaria proposta direttamente agli Utenti dai Liberi
              Professionisti ed eseguita da questi ultimi in assoluta autonomia.
              Pertanto, l&apos;Utente rinuncia espressamente ad avanzare
              richieste risarcitorie nei confronti di Lami per i danni tutti,
              diretti ed indiretti, patrimoniali e non patrimoniali, a
              quest&apos;ultimo cagionati dal comportamento colposo o doloso dei
              Liberi Professionisti.
            </Typography>

            <Typography marginBottom="medium">
              7.5. Lami si riserva il diritto di sospendere temporaneamente il
              Servizio per motivi di necessità (manutenzione, trasferimenti,
              riparazione, aggiornamenti del Software, ecc.). Fermi gli obblighi
              di diligenza previsti dalla legge, l&apos;Utente rinuncia a
              richiedere a Lami eventuali danni, di qualunque natura, subiti in
              occasione o a seguito di tali interruzioni. In ogni caso, ogni
              comunicazione inerente alla funzionalità del Software fornito
              potrà essere inviata tramite e-mail all&apos;indirizzo
              info@lamimed.it.
            </Typography>

            <Typography marginBottom="medium">
              7.6. L&apos;Utente è inoltre il solo responsabile delle attività
              che svolgerà attraverso il Software. Lami non ha il controllo
              diretto sulle informazioni e sui dati immessi nel sistema dall
              &apos;Utente, non fornisce alcuna garanzia sulla legalità,
              accuratezza o qualità dei medesimi e non potrà essere ritenuta
              responsabile per ciò che concerne il contenuto e le attività
              svolte dall&apos;Utente e non gestite o controllate da Lami.
            </Typography>

            <Typography marginBottom="medium">
              7.7. L&apos;Utente si impegna a manlevare e a tenere indenni Lami
              da qualsiasi responsabilità o conseguenza di azioni promosse da
              terzi riguardanti le informazioni e i dati immessi nel sistema
              dall&apos; Utente stesso.
            </Typography>

            <Typography marginBottom="medium">
              7.8. L&apos;Utente è conscio che Lami potrà interrompere la
              prestazione del Servizio in presenza di motivati problemi di
              sicurezza e/o di riservatezza, anche oltre il limite delle 24 ore
              lavorative, dandone comunicazione all&apos;Utente in qualsiasi
              forma e/o mezzo. In ogni caso l&apos;Utente non potrà pretendere
              alcuna somma a titolo di risarcimento, penale, e indennizzo per
              l&apos;interruzione del Servizio.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 8 – Proprietà intellettuale
            </Typography>

            <Typography marginBottom="medium">
              8.1. Con la sottoscrizione dei presenti termini e condizioni
              l&apos;Utente non diventa titolare di alcun diritto di proprietà
              intellettuale o di altra natura sul Software. Il Software è di
              esclusiva proprietà, in ogni sua parte, ivi inclusi il codice
              sorgente ed oggetto, il know-how, i progetti, il layout e le
              immagini di Lami, il quale detiene tutti i diritti patrimoniali e
              morali d&apos;autore e ogni diritto di proprietà industriale o di
              altra natura.
            </Typography>

            <Typography marginBottom="medium">
              8.2. Lami concede l&apos;utilizzo del Software esclusivamente alle
              condizioni di cui al presente contratto e ai suoi allegati. Tutti
              i diritti non esplicitamente concessi sono riservati a Lami.
            </Typography>

            <Typography marginBottom="medium">
              8.3. L&apos;Utente che venga in contatto o a conoscenza di
              informazioni, know-how, documenti, pratiche di lavoro, codici
              oggetto, codici sorgente, stili gestionali, operazioni aziendali
              quotidiane, capacita, sistemi, strategie attuali e future,
              informazioni di marketing, finanziarie, software, tecnologie,
              processi, procedure, metodi, applicazioni e altri aspetti relativi
              al Software che appartengano o si riferiscano a Lami o ad altri
              clienti della stessa, riconosce che tali informazioni, know-how,
              documenti, etc.., sono riservate. Conseguentemente l&apos;Utente
              si obbliga a garantirne la segretezza riconoscendo altresì che le
              stesse sono e rimangono di esclusiva titolarità di Lami a cui
              appartengono o a cui si riferiscono.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 9 - Utilizzo del Software e responsabilità dell&apos;utente
            </Typography>

            <Typography marginBottom="medium">
              9.1. L&apos;accesso e l&apos;uso del Software, la visualizzazione
              delle pagine web, compresa la comunicazione, la possibilità di
              scaricare informazioni sui servizi e l&apos;acquisto degli stessi
              tramite il Software, costituiscono attività condotte dall&apos;
              Utente esclusivamente per usi personali estranei a qualsiasi
              attività commerciale, imprenditoriale e professionale.
            </Typography>

            <Typography marginBottom="medium">
              9.2. Il Software non deve essere utilizzato in modo improprio,
              bensì solo nei modi indicati dalle presenti termini e condizioni e
              consentiti dalla legge. È vietato interferire con il Software o
              tentare di accedervi utilizzando un metodo diverso
              dall&apos;interfaccia e dalle istruzioni fornite da Lami.
            </Typography>

            <Typography marginBottom="medium">
              9.3. È vietata all&apos;Utente ogni cessione, divulgazione, invio,
              distribuzione, presentazione, trasmissione o comunicazione
              pubblica, locazione e/o noleggio del Software, come anche ogni
              riproduzione, elaborazione, traduzione, adattamento o sviluppo a
              ritroso (Reverse Engineering), decompilazione o disassemblaggio o
              comunque ogni operazione per la quale la legge sul diritto
              d&apos;autore (i.e. L. n. 633 del 22 aprile 1941 e successive
              modificazioni) richieda l&apos;autorizzazione di Lami.
            </Typography>

            <Typography marginBottom="medium">
              9.4. Sui documenti, software, applicazioni etc. saranno presenti
              riferimenti che evidenziano i diritti di proprietà intellettuale e
              industriale di Lami. È vietato rimuovere, oscurare o alterare
              detti riferimenti ed eventuali note legali visualizzate nel
              Software o insieme a esso.
            </Typography>

            <Typography marginBottom="medium">
              9.5. I requisiti minimi di sistema per la creazione
              dell&apos;account Lami: (i) avere un computer o uno smartphone;
              (ii) avere una connessione dati ADSL funzionante (iii); utilizzare
              preferibilmente i browser Google Chrome versione 53.0.2785,
              Mozzilla versione 48.0 o 46.0.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 10 - Trattamento dei dati
            </Typography>

            <Typography marginBottom="medium">
              10.1. I dati dell&apos;Utente sono trattati conformemente a quanto
              previsto dalla normativa in materia di protezione dei dati
              personali, come specificato nell&apos;apposita sezione contenente
              l &apos;informativa ai sensi dell&apos;art. 13 D.lgs. 30 giugno
              2003, come modificato dal d.lgs. 101/18 e dell&apos;art. 13
              Regolamento UE 2016/679 (Privacy Policy). Per più informazioni
              accedere alla privacy policy del sito al link:&nbsp;
              <a href="https://lamimed.it/privacy-policy">
                https://lamimed.it/privacy-policy
              </a>
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 11 – Cessione del contratto
            </Typography>

            <Typography marginBottom="medium">
              11.1. Lami si riserva la facoltà di cedere il Contratto di cui
              alle presenti Condizioni e Termini di Utilizzo ad altro soggetto
              in grado di assicurare all&apos;Utente le medesime funzionalità
              del Software. Tale facoltà è esclusa per l&apos;Utente.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 12 – Clausola di salvaguardia
            </Typography>

            <Typography marginBottom="medium">
              12.1. Nell&apos;ipotesi in cui una delle clausole delle presenti
              condizioni generali d&apos;uso fosse nulla per qualsivoglia motivo
              ciò non comprometterà in nessun caso la validità e il rispetto
              delle altre disposizioni figuranti nelle presenti condizioni
              generali d&apos;uso.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 13 – Contatti
            </Typography>

            <Typography marginBottom="medium">
              13.1. Ogni richiesta di informazione potrà essere inviata via mail
              al seguente indirizzo info@lamimed.it o via whatsapp al seguente
              recapito telefonico: +39 351 7559363 e posta al seguente
              indirizzo: Via Ariberto 8, 20123, Milano – ITALY.
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginBottom="medium"
              marginTop="xlarge"
            >
              Art. 14 – Legge applicabile e foro competente
            </Typography>

            <Typography marginBottom="medium">
              14.1. Le presenti condizioni generali d&apos;uso sono disciplinate
              dal diritto italiano ed interpretate in base ad esso, fatta salva
              qualsiasi diversa norma imperativa prevalente del paese di
              residenza abituale dell&apos;acquirente. Di conseguenza l&apos;
              interpretazione, esecuzione e risoluzione delle condizioni
              generali d&apos;uso sono soggette esclusivamente alla legge
              Italiana.
            </Typography>

            <Typography marginBottom="medium">
              Eventuali controversie inerenti e/o conseguenti alle stesse
              dovranno essere risolte in via esclusiva dall&apos;autorità
              giurisdizionale italiana. In particolare, qualora il l&apos;
              acquirente rivesta la qualifica di consumatore, le eventuali
              controversie dovranno essere risolte dal tribunale del luogo di
              domicilio o residenza dello stesso in base alla legge applicabile.
            </Typography>

            <Typography marginBottom="medium">
              Le presenti condizioni sono state redatte in data 06/12/2020.
            </Typography>
          </Grid.Wrapper>
        </S.Wrapper>
      </SectionWrapper>
    </>
  );
};

export default TermsAndConditions;
